import { render } from "./JsonViewer.vue?vue&type=template&id=2bdef683&scoped=true"
import script from "./JsonViewer.vue?vue&type=script&lang=js"
export * from "./JsonViewer.vue?vue&type=script&lang=js"

import "./JsonViewer.vue?vue&type=style&index=0&id=2bdef683&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdef683"]])

export default __exports__